import List from './List.vue'
import SendToList from './SendToList.vue'
import SendLog from './SendLog.vue'
import Form from './Form.vue'
import MessageStatus from './MessageStatus.vue'
import UrlPreviewForm from './UrlPreviewForm.vue'
import TestForm from './TestForm.vue'
import SendTo from './SendTo.vue'

export default {
  install (Vue) {
    Vue.component('messages-list', List)
    Vue.component('messages-send-to-list', SendToList)
    Vue.component('messages-send-log', SendLog)
    Vue.component('messages-form', Form)
    Vue.component('message-status', MessageStatus)
    Vue.component('url-preview-form', UrlPreviewForm)
    Vue.component('message-test-form', TestForm)
    Vue.component('message-send-to-info', SendTo)
  }
}



// WEBPACK FOOTER //
// ./src/components/messages/index.js